<script>
export default {
  name: "SvgIcon",
  props: {
    // 图标名称
    icon: {
      type: String,
      default: ''
    },
    // 图标宽度
    width: {
      type: String,
      default: ''
    },
    // 图标高度
    height: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.icon}`;
    },
    style() {
      const w = this.width.replace(/px/g, ""),
            h = this.height.replace(/px/g, "")
      return {
        width: w,
        height: h
      }
    }
  }
}
</script>

<template>
<svg :style="style">
  <use :xlink:href="iconName"></use>
</svg>
</template>

<style lang="less" scoped>
svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>